/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { subsidy_CreateSubsidyReportRequest } from '../models/subsidy_CreateSubsidyReportRequest';
import type { subsidy_FileSubsidyReportRequest } from '../models/subsidy_FileSubsidyReportRequest';
import type { subsidy_RecordSubsidyReportDecisionRequest } from '../models/subsidy_RecordSubsidyReportDecisionRequest';
import type { subsidy_SubsidyReportItemResponse } from '../models/subsidy_SubsidyReportItemResponse';
import type { subsidy_SubsidyReportSheetResponse } from '../models/subsidy_SubsidyReportSheetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubsidyReportsService {
    /**
     * Raise a Sozialdepartement item by hand
     * Raises an Antrag, Mutation or Austritt for the contract version, for a case the contract hooks missed (#2003). One open item per version and kind: a second one answers 409 SUBSIDY_REPORT_EXISTS. The version must be subsidised through a Beitragsfaktor office (422 SUBSIDY_REPORT_NOT_ELIGIBLE). Admin only.
     * @param id Contract version ID
     * @param request Kind and note
     * @returns subsidy_SubsidyReportItemResponse Created
     * @throws ApiError
     */
    public static postApiV1ContractsSubsidyReports(
        id: string,
        request: subsidy_CreateSubsidyReportRequest,
    ): CancelablePromise<subsidy_SubsidyReportItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/contracts/{id}/subsidy-reports',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Record the city's decision on a Sozialdepartement item
     * approved writes the decision date and number to the contract version and clears its invoice hold (subsidy_decision_pending); rejected writes the decision date only and keeps the hold. Both move the item from filed to a final state in one transaction. Admin only (#2003).
     * @param id Workflow item ID
     * @param request Decision
     * @returns subsidy_SubsidyReportItemResponse OK
     * @throws ApiError
     */
    public static postApiV1SubsidyReportsDecision(
        id: string,
        request: subsidy_RecordSubsidyReportDecisionRequest,
    ): CancelablePromise<subsidy_SubsidyReportItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/subsidy-reports/{id}/decision',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Mark a Sozialdepartement item filed
     * Moves the item from to_file to filed and writes the filing date to the item and to the contract version (subsidy_application_filed_on) in one transaction. Needs a valid BF and SBU confirmation on the version (409 SUBSIDY_REPORT_DOCUMENTS_MISSING; errors names the missing one). Admin only (#2003).
     * @param id Workflow item ID
     * @param request Filing date
     * @returns subsidy_SubsidyReportItemResponse OK
     * @throws ApiError
     */
    public static postApiV1SubsidyReportsFile(
        id: string,
        request: subsidy_FileSubsidyReportRequest,
    ): CancelablePromise<subsidy_SubsidyReportItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/subsidy-reports/{id}/file',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Copy-ready sheet of a Sozialdepartement item
     * The item with the values the office pastes into Kollab, in the server's order (one constant), read live from the contract version, plus whether Mark filed is allowed (a valid BF and SBU confirmation, #2002). Admin only (#2003).
     * @param id Workflow item ID
     * @returns subsidy_SubsidyReportSheetResponse OK
     * @throws ApiError
     */
    public static getApiV1SubsidyReportsSheet(
        id: string,
    ): CancelablePromise<subsidy_SubsidyReportSheetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/subsidy-reports/{id}/sheet',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * CSV export of the Sozialdepartement queue
     * One row per item: the sheet fields in the sheet's order, then kind, state, due date, filing date, decision date and decision number. Filters on the item's due date (from, to, inclusive) and state. UTF-8 with BOM, semicolon separator, for Excel de-CH (#2003).
     * @param from First due date (YYYY-MM-DD)
     * @param to Last due date (YYYY-MM-DD)
     * @param state to_file, filed, approved, rejected or cancelled
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiV1SubsidyReportsExportCsv(
        from?: string,
        to?: string,
        state?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/subsidy-reports/export.csv',
            query: {
                'from': from,
                'to': to,
                'state': state,
            },
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
            },
        });
    }
}
